<template>
  <div class="main-container">
    <vxe-grid
        style="width: 100%"
        v-bind="gridOptions"
        :loading="isLoading"
        :columns="tableColumns"
        :data="userInfoList">
      <template #top>
        <div class="top-content">
          <div style="height: 30px; display: flex; align-items: center;">
            <span class="fs-18 fw-bold title-content">用户管理-所有用户</span>
            <div class="total-count-content">用户数{{ totalCount }}</div>
            <i v-if="!isLoading" class="el-icon-refresh pointer refresh-icon" @click="refreshData"></i>
            <i v-if="isLoading" class="el-icon-loading pointer refresh-icon"></i>
          </div>
        </div>
      </template>
      <template #search-filter="{column}">
        <div class="flex flex-row justify-space-between">
          <span>{{ column.title }}</span>
          <div class="flex">
            <span class="reset-btn pointer" v-show="showHeaderReset(column)" @click="resetSearch(column)">重置</span>
            <el-popover
                ref="popoverRef"
                popper-class="search-filter-popover"
                placement="bottom">
              <div slot="reference">
                <i class="el-icon-search pointer"/>
              </div>
              <div class="search-input-wrapper">
                <el-input
                    v-model="searchKeyWords[column.field]"
                    :clearable="true"
                    class="search-input"
                    @keyup.enter.native="handleSearch(column)"
                    placeholder="请输入"/>
                <span class="search-confirm" @click="handleSearch(column)">确定</span>
              </div>
            </el-popover>
          </div>
        </div>
      </template>
      <template #handle-operation="{row}">
        <div class="operate-content">
          <span class="pointer edit-btn" @click="handleEdit(row)">编辑</span>
          <el-divider direction="vertical"></el-divider>
          <span class="pointer edit-btn" @click="handleChangePassword(row)">修改密码</span>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
              confirm-button-text='确定'
              cancel-button-text='取消'
              icon="el-icon-info"
              icon-color="red"
              title="是否确认删除该条用户？"
              @confirm="handleDelete(row)"
          >
            <div slot="reference">
              <span class="pointer del-btn">删除</span>
            </div>
          </el-popconfirm>
        </div>
      </template>
      <template #pager>
        <vxe-pager
            :total="totalCount"
            :page-size="pageSize"
            :current-page.sync="page"
            :page-sizes="[20, 30, 50]"
            :layouts="['Sizes', 'PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'FullJump']"
            @page-change="handlePageChange">
        </vxe-pager>
      </template>
    </vxe-grid>
    <CommonDrawer
      class="drawer-content"
      :propParams="orderEditParams"
      :showDrawer="orderEditVisible"
      @close="orderEditVisible = false"
    >
      <div slot="drawer-content" class="order-info-content">
        <el-form label-width="118px" v-model="userInfo">
          <el-form-item label="姓名">
            <el-input v-model="userInfo.name" disabled />
          </el-form-item>
          <el-form-item label="电话号码">
            <el-input v-model="userInfo.telNum" />
          </el-form-item>
          <el-form-item label="车牌号">
            <div style="display: flex; flex-direction: column; gap: 4px">
              <div v-for="(item, index) in licensePlate" :key="index" style="display: flex; gap: 4px; align-items: center;">
                <el-input :value="item" @input="handleLicensePlateChange(index, $event)" />
                <i class="el-icon-circle-plus-outline license-plate-handle-button" @click="handleAddLicensePlate(index)" />
                <i class="el-icon-remove-outline license-plate-handle-button" @click="handleRemoveLicensePlate(index)" />
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="drawer-footer">
        <el-button size="medium" @click="orderEditVisible = false">取消</el-button>
        <el-button size="medium" type="primary" @click="handleEditOrder">提交</el-button>
      </div>
    </CommonDrawer>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import CommonDrawer from "@/components/common/commonDrawer.vue";

export default {
  name: "userManagement",
  components: {CommonDrawer},
  data() {
    return {
      gridOptions: {
        height: 'auto',
        border: 'full',
        round: true,
        showOverflow: 'tooltip',
        columnConfig: {
          resizable: true,
        },
        rowConfig: {
          isHover: true,
          height: 38,
        },
      },
      tableColumns: [
        {
          field: 'id',
          title: 'ID',
          width: 150,
        }, {
          field: 'name',
          title: '姓名',
          width: 120,
        }, {
          field: 'licensePlate',
          title: '车牌号',
          width: 300,
          minWidth: 140,
          slots: {
            header: 'search-filter',
          },
        }, {
          field: 'telNum',
          title: '电话号码',
          width: 150,
          slots: {
            header: 'search-filter',
          },
        }, {
          field: 'password',
          title: '密码',
          width: 150,
        }, {
          field: 'remark',
          title: '备注',
          minWidth: 120,
        }, {
          field: 'operation',
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 160,
          slots: {
            default: 'handle-operation'
          },
        }
      ],
      isLoading: false,
      page: 1,
      pageSize: 20,
      totalCount: 0,
      userInfoList: [],
      searchKeyWords: {},
      requestParams: {
      },
      orderEditVisible: false,
      orderEditParams: {
        title: '编辑订单',
        showFooter: true,
      },
      userInfo: {},
      licensePlate: [],
      url: '',
      srcList: [''],
      showConfirmRefund: false,
      refundInfo: {},
      refundLicense: ''
    }
  },
  computed: {
    ...mapState([
      'orderManageSetting'
    ]),
  },
  watch: {
    orderManageSetting: {
      handler (newVal) {
        if (newVal && JSON.stringify(newVal) !== '{}') {
          this.pageSize = newVal.defaultShowRowNum.data || 20
          this.initData()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      getUserInfo: 'getUserInfo',
      removeUser: 'removeUser',
      editUserInfo: 'editUserInfo',
      updateUserPassword: 'updateUserPassword',
    }),
    formatParams() {
      this.page = 1
      this.requestParams = {}
    },
    initData() {
      this.formatParams()
      this.getUserInfoList()
    },
    handlePageChange({currentPage, pageSize}) {
      this.pageSize = pageSize
      this.page = currentPage
      this.getUserInfoList()
    },
    getUserInfoList() {
      this.isLoading = true
      let params = Object.assign({}, this.requestParams, {
        page: this.page,
        pageSize: this.pageSize,
      })
      this.getUserInfo(params).then(res => {
        if(res.paCode !== '000') {
          this.$message.error('获取用户订单失败' + res.paMsg);
        } else {
          this.totalCount = res.paData.totalCount;
          this.userInfoList = res.paData.data;
        }
        this.isLoading = false
      })
    },
    refreshData() {
      this.formatParams()
      this.getUserInfoList()
    },
    searchParamsKey(field) {
      switch (field) {
        case 'telNum':
          return 'telNum'
        case 'licensePlate':
          return 'licensePlate'
        default:
          return ''
      }
    },
    handleSearch(column) {
      let searchKey = this.searchParamsKey(column.field)
      this.requestParams[searchKey] = this.searchKeyWords[searchKey]
      this.getUserInfoList()
    },
    showHeaderReset(column) {
      let searchKey = this.searchParamsKey(column.field)
      return !!this.requestParams?.[searchKey]
    },
    resetSearch(column) {
      let searchKey = this.searchParamsKey(column.field)
      delete this.requestParams?.[searchKey]
      delete this.searchKeyWords[searchKey]
      this.getUserInfoList()
    },
    handleEdit(row) {
      this.userInfo = this.cloneDeep(row)
      this.licensePlate = JSON.parse(this.userInfo.licensePlate)
      this.orderEditVisible = true
    },
    handleChangePassword (row) {
      this.$prompt( '请输入密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '请填写内容'
      }).then(({ value }) => {
        const params = {
          openid: row.id,
          password: value
        }
        this.updateUserPassword(params).then(res => {
          if (res.paCode !== '000') {
            this.$message.error(res.paMsg || '修改密码失败')
          } else {
            this.$message.success(res.paMsg || '操作成功')
            this.refreshData()
          }
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '取消输入'
        // });
      });
    },
    handleDelete(row) {
      this.removeUser({
        openid: row.id
      }).then(res => {
        if (res.paCode !== '000') {
          this.$message.error(res.paMsg || '操作失败');
        } else {
          this.$message.success(res.paMsg || '操作成功');
          this.refreshData()
        }
      })
    },
    handleLicensePlateChange(index, value) {
      // 修改数组中的第index个元素并触发响应式
      this.licensePlate.splice(index, 1, value)
    },
    handleAddLicensePlate(index) {
      // 在index的位置插入一个空字符串
      this.licensePlate.splice(index + 1, 0, '')
    },
    handleRemoveLicensePlate(index) {
      // 删除index位置的元素
      this.licensePlate.splice(index, 1)
    },
    handleEditOrder () {
      const params = {
        openid: this.userInfo.id,
        name: this.userInfo.name,
        licensePlate: JSON.stringify(this.licensePlate),
        telNum: this.userInfo.telNum,
      }
      console.log(params)
      this.setLoading(true)
      this.editUserInfo(params).then(res => {
        this.setLoading(false)
        if (res.paCode !== '000') {
          this.$message.error(res.paMsg || '操作失败');
        } else {
          this.$message.success(res.paMsg || '操作成功');
          this.orderEditVisible = false
          this.refreshData()
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main-container {
  width: 100%;
  height: 100%;

  /deep/ .is-assigned-order {
    background-color: #ff5232;
    color: white;
  }
  .top-content {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
  }
  .total-count-content {
    margin-right: 8px;
    font-size: 14px;
    color: #5b6b7e;
    border: 1px solid #5b6b7e;
    border-radius: 5px;
    padding: 1px 6px;
    font-weight: bold;
  }
  .title-content {
    margin-right: 16px;
  }
  .refresh-icon {
    font-size: 18px;
    color: #4a90e2;
  }
  .reset-btn {
    margin-right: 6px;
    font-weight: lighter;
    color: #6891c0;
  }
  .operate-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    .el-divider--vertical {
      margin: 0;
    }

    .edit-btn {
      color: #4a90e2;
    }

    .del-btn {
      color: #b81414;
    }
  }
  .license-plate-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .order-info-content {
    padding: 16px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    .license-plate-handle-button {
      font-size: 30px;
      cursor: pointer;
      &:hover {
        color: #4a90e2;
      }
    }
  }
}
.search-input-wrapper {
  display: flex;
  width: 330px;
  height: 34px;
  align-items: center;
  .search-input {
    flex: 1;
    margin-left: 0;
  }
  /deep/ .el-input__inner {
    border-radius: 5px;
    height: 35px;
  }
  .search-confirm {
    color: #4a90e2;
    margin: 0 8px;
    text-align: center;
    cursor: pointer;
  }
}
/deep/ .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0;
}
</style>